import { render, staticRenderFns } from "./CustomDatabasePage.vue?vue&type=template&id=eb56fd16&scoped=true"
import script from "./CustomDatabasePage.vue?vue&type=script&lang=js"
export * from "./CustomDatabasePage.vue?vue&type=script&lang=js"
import style0 from "./CustomDatabasePage.vue?vue&type=style&index=0&id=eb56fd16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb56fd16",
  null
  
)

export default component.exports